import AWS from 'aws-sdk';
import axios from 'axios';

// Initialize the S3 client
const initS3 = () => {
    const S3_BUCKET = "BUCKEt_NAME"; // Replace with your bucket name
    const REGION = "REGION"; // Replace with your region

    AWS.config.update({
        accessKeyId: "ACCESS_ID",
        secretAccessKey: "SECRET_KEY",
    });

    return new AWS.S3({
        params: { Bucket: S3_BUCKET },
        region: REGION,
        httpOptions: {
            timeout: 1200000 // 5 minutes timeout
        }
    });
};

// Function to upload a file
export const uploadFileToS3 = (file, onProgress, onSuccess, onError) => {
    const s3 = initS3();
    const S3_BUCKET = "files-dev-staging"; // Replace with your bucket name
    const key = `ListingFiles/uploadFile-${Date.now().toString()}-${file.name}`;
    const params = {
        Bucket: S3_BUCKET,
        Key: key,
        ACL: 'public-read', // Adjust permissions as needed
        Body: file,
        ContentDisposition: 'inline',
    };

    s3.putObject(params)
        .on('httpUploadProgress', (evt) => {
            const { loaded, total } = evt;
            let percent = Math.floor((loaded * 100) / total);
            onProgress(percent);
        })
        .promise()
        .then(() => {
            const fileUrl = s3.getSignedUrl('getObject', {
                Bucket: params.Bucket,
                Key: key,
            });
            onSuccess({ key, location: fileUrl });
        })
        .catch((error) => {
            console.error(error);
            onError(error);
        });
};

export const uploadWithPresignedUrl = async (data) => {
    try {
        const { url, file, fileType, setAwsFile, awsFile, key } = data
        // Use axios to upload the file to S3
        const response = await axios.put(url, file, {
            headers: {
                'Content-Type': fileType,
            },
            onUploadProgress: progressEvent => {
                const { loaded, total } = progressEvent;
                let percent = Math.floor((loaded * 100) / total);
                setAwsFile({
                    ...awsFile,
                    fileProgressPercentage: percent,
                    awsFileInProgress: true,
                });
            },
        });
        // Check if the upload was successful
        if (response.status === 200) {
            // Create a URL object
            const newUrl = new URL(url);

            // Extract the base URL
            const baseUrl = `${newUrl.protocol}//${newUrl.host}${newUrl.pathname}`;
            const responseObject = {
                key,
                location: baseUrl,
            };
            setAwsFile({
                ...awsFile,
                awsFileInProgress: false,
            });
            return responseObject
            console.log('File uploaded successfully');
        } else {
            console.error('File upload failed');
            setAwsFile({
                ...awsFile,
                awsFileInProgress: false,
            });
        }
    } catch (error) {
        setAwsFile({
            ...awsFile,
            awsFileInProgress: false,
        });
        console.error('Error uploading file:', error);
    }
};

